module.exports = __webpack_public_path__ + "img/27.d09f46f9.jpg";